import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area, ReferenceLine, ScatterChart, ZAxis, Scatter } from 'recharts';
import React, { Fragment, useState, useEffect } from 'react';
import {
  makeStyles, Slider, Switch
} from '@material-ui/core';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { styled } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FormControlLabel } from '@mui/material';
import html2canvas from 'html2canvas';
const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));
const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});
function valuetext(value) {
  return `${value}°C`;
}

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 30px',
    marginBottom: '50px',
    padding: '20px 20px'
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center'
  },
  legendContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '-15px',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    }
  },
  legend: {
    display: 'flex'
  },
  legendText: {
    marginLeft: '2vh',
    marginRight: '2vh',
    color: 'var(--gmi-color)',
    fontSize: '0.8em'
  },
  legendGreen: {
    backgroundColor: 'var(--console-green)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  legendRed: {
    backgroundColor: 'var(--console-red)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  legendGrey: {
    backgroundColor: 'var(--console-grey)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  consoleContainer: {
    justifyContent: 'space-evenly'
  }
}));

const Charts = ({ className, mesTemperatures, urlCaptureImage, imgSource, setImgSource, typeAnita, chartCalledFrom,descriptionCourbe, setDescriptionCourbe, ...rest }) => {
  // State with list of all checked item
  const [checked, setChecked] = useState([]);
  const [coloredTC, setColoredTC] = React.useState(0);
  const [vacuumChart, setVacuumChart] = React.useState(1);
  const [tempChart, setTempChart] = React.useState(1);
  
  const [comparingNumber, SetComparingNumber] = React.useState(5);
  var checkList = [];
  var ele = document.getElementsByName('foo');

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      setChecked(checkList)
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox')
          ele[i].checked = true;
      }
    } else {
      setChecked([])
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox')
          ele[i].checked = false;
      }
    }
  };

  const handleCheckFirstZone = (event) => {

    if (event.target.checked) {
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox' && i!=(ele.length-2))
          ele[i].checked = false;
      }
      var updatedList = [];
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox' && parseInt(ele[i].value.slice(2)) <= (parseInt(typeAnita[0])/2))
          {ele[i].checked = true;
            updatedList = [...updatedList, ele[i].value];}
      }
      setChecked(updatedList)
    } else {
      setChecked([])
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox')
          ele[i].checked = false;
      }
    }
  };


  const handleCheckSecondZone = (event) => {

    if (event.target.checked) { 
      for (var i = 0; i < (ele.length); i++) {
        if (ele[i].type == 'checkbox' && (i!=(ele.length-1)))
          ele[i].checked = false;
      }
      var updatedList = [];
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox' && parseInt(ele[i].value.slice(2)) > (parseInt(typeAnita[0])/2) && i != ele.length-2 )
          {ele[i].checked = true;
            if(i!=ele.length-1)
            updatedList = [...updatedList, ele[i].value];}
      }
      setChecked(updatedList)
    } else {
      setChecked([])
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == 'checkbox')
          ele[i].checked = false;
      }
    }
  };


  // Add/Remove checked item from list
  const handleCheck = (event) => {
    var updatedList = [...checked];
    // console.log(checked)
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  useEffect(() => {
    setChecked(checkList)
    for (var i = 0; i < ele.length; i++) {
      if (ele[i].type == 'checkbox')
        ele[i].checked = true;
    }
    if(chartCalledFrom === "0")
    descriptionprocess()
  }
, [])

  // Generate string of checked items

  const checkedItems = checked.length
    ? checked.sort(function (a, b) {
      if (parseInt(a.substring(2, 4)) < parseInt(b.substring(2, 4))) return -1;
      if (parseInt(a.substring(2, 4)) > parseInt(b.substring(2, 4))) return 1;
      return 0;
    }).reduce((total, item) => {
      return total + ", " + item;
    })
    : "";


  // Return classes based on whether item is checked
  var isChecked = (item) =>
    checked.includes(item) ? "checked-item" : "not-checked-item";

  const [detail, setDetail] = useState(false);
  const x = parseInt(mesTemperatures[1][0], 10);
  const y = parseInt(mesTemperatures[mesTemperatures.length - 2][0], 10);
  function handleClick(e) {
    e.preventDefault();
    setDetail(!detail)
  }
  var check = false;

  //check pour eviter les boucle infini, on relance ce code quand il y a un changement au niveau du slider
  // on verifi qu'on a pas deja ajouter le TCXX pour ne pas avoir de redondance 
  const [value, setValue] = useState([parseInt(0, 10), parseInt(mesTemperatures.length - 1, 10)])
  var nom = 'TC'
  var nom2 = 'TC'
  var list = [];
  var listVacuum = [];
  var nbTCS = parseInt(typeAnita[0]) + 1
  function descriptionprocess() {
    var description = []

    for (let i = value[0]; i < value[1]; i++) 
    {
      var listTCs = ""
      let calcul = 0
      for (var x = 2; x <= nbTCS; x++) {
        if ((Math.abs(parseFloat(mesTemperatures[i][1]) - parseFloat(mesTemperatures[i][x])) >= comparingNumber) && (parseFloat(mesTemperatures[i][x]) !== 0)) {
          calcul++;
          listTCs += "[ TC" + (x - 1) + " " + mesTemperatures[i][x] + "° ]"
        }
      }
      if (calcul != 0) {
        var s = calcul === 1 ? " has exceeded " : "s have exceeded "
        description.push([`[ Minute : ${i} ] `, calcul, `thermocouple${s} the SetPoint ${mesTemperatures[i][1]} with  +/- ${comparingNumber}° `, listTCs])
        //description += listTCs + "\n"
      }
    }
    setDescriptionCourbe(description)
  }

  const deleteItem = (index) => {
    let temp = descriptionCourbe.filter((item, i) => i !== index);
    setDescriptionCourbe(temp);
  };





  if (!check) {

    for (var z = 0; z < (mesTemperatures[0][14] === "TC13" ? 24 : 12); z++) {
      nom = 'TC' + (z + 1);
      if (!(nom in checkList) && parseInt(mesTemperatures[5][z + 2]) !== 0) {
        checkList.push(nom)
      }
    }

    for (var i = value[0]; i <= value[1]; i++) {
      const obj = {};
      const objVacuum = {};
      obj.time = i;
      objVacuum.time = i;
      if (mesTemperatures[0][14] === "TC13") {
        obj.SP = mesTemperatures[i][1];

        obj.SPMin = parseFloat(mesTemperatures[i][1])-parseFloat(comparingNumber);
        obj.SPMax = parseFloat(mesTemperatures[i][1])+parseFloat(comparingNumber);
        
        objVacuum.V1 = mesTemperatures[i][26];
        objVacuum.V2 = mesTemperatures[i][27];
        obj.Z1 = mesTemperatures[i][28];
        obj.Z2 = mesTemperatures[i][29];

        for (var z = 0; z < 12; z++) {
          nom = 'TC' + (z + 1);
          nom2 = 'TC' + (z + 13);

          if (parseInt(mesTemperatures[i][z + 2]) !== 0) {
            obj[nom] = parseInt(mesTemperatures[i][z + 2]);
          }
          if (parseInt(mesTemperatures[i][z + 14]) !== 0) {
            obj[nom2] = parseInt(mesTemperatures[i][z + 14]);
          }
        }
      }
      else {
        obj.SP = mesTemperatures[i][1];
        objVacuum.V1 = mesTemperatures[i][14];
        objVacuum.V2 = mesTemperatures[i][15];
        obj.Z1 = mesTemperatures[i][16];
        obj.Z2 = mesTemperatures[i][17];
        obj.SPMin = parseFloat(mesTemperatures[i][1])-parseFloat(comparingNumber);
        obj.SPMax = parseFloat(mesTemperatures[i][1])+parseFloat(comparingNumber);
       

        for (var z = 0; z < 6; z++) {
          nom = 'TC' + (z + 1);
          nom2 = 'TC' + (z + 7);


          if (parseInt(mesTemperatures[i][z + 2]) !== 0) {
            obj[nom] = parseInt(mesTemperatures[i][z + 2]);
          }
          if (parseInt(mesTemperatures[i][z + 8]) !== 0) {
            obj[nom2] = parseInt(mesTemperatures[i][z + 8]);
          }
        }
      }
      list.push(obj);
      listVacuum.push(objVacuum)

      check = true;
    }

  }
  const data = list;
  const data2 = listVacuum;

  const handleChange = (event, newValue) => {
    if (newValue[0] !== newValue[1])
      setValue(newValue);
    check = false;
    descriptionprocess()
  };
  const CustomTooltip = ({ active, payload, label }) => {


    if (active && payload && payload.length) {
      return (

        <div className="custom-tooltip" style={{maxWidth:'500px', backgroundColor:'white', border:'0.1rem solid #3ca2c3'}}>
          <p className="label" style={{ margin:'10px', whiteSpace:'nowrap'}}>{`Minute ${label} min | SetPoint ${payload[0].value}°`}</p>
          {payload.map((x,index)=>(x.name!=='SP'&&x.name!=='Z1'&&x.name!=='Z2')?<span style={{color:x.color, margin:'1px', whiteSpace:'nowrap'}}>{`[${x.name} ${x.value}°]`}</span>:(x.name==='Z1'||x.name==='Z2')?<span style={{color:x.color, margin:'1px', whiteSpace:'nowrap'}}>{`[${x.name} ${x.value}%]`}</span>:<></>)}
        </div>

      );
    }

    return null;
  };
  
  const imprim = () => {
    {
     if (chartCalledFrom === "1") 
      {html2canvas(document.getElementById('my-node'))
        .then(function (canvas) {
          //document.getElementById('x').appendChild(canvas);

          var base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
          setImgSource(base64URL)
         
          //console.log(base64URL)
        })
        toast.info("Image taken succefully !", {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      } else 
        {htmlToImage.toBlob(document.getElementById('my-node'))
          .then(function (blob) {
            urlCaptureImage[0] = blob
            toast("Wow so easy !");
            window.saveAs(blob, 'temp_vacum_' + value[0] + 'min-' + value[1] + 'min.png');
          })
          toast.info("Image downloaded succefully !", {
            position: toast.POSITION.BOTTOM_RIGHT
          });
        }
    }

    /*  var node = document.getElementById('my-node');
  
      htmlToImage.toPng(node)
        .then(function (dataUrl) {
          urlCaptureImage[0]=dataUrl
          var img = new Image();
          img.src = dataUrl;
          document.body.appendChild(img);
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error);
        });*/

    /* htmlToImage.toBlob(document.getElementById('my-node'))
       .then(function (blob) {
         urlCaptureImage[0] = blob
         window.saveAs(blob, 'temp_vacum_' + value[0] + 'min-' + value[1] + 'min.png');
       });
 
 */

    //urlCaptureImage[0]=url
    //  newImg.src = url;
    //  document.getElementById("x").appendChild(newImg);

  }






  return (


    <   >


      <center>
      <ToastContainer />
        <FormControlLabel
          control={<Android12Switch defaultChecked checked={!coloredTC} onChange={(e) => { setColoredTC(!coloredTC) }} />}
          label={!coloredTC ? "Colored TCs" : "Yellow/Blue TCs per zone"}
        />
        <FormControlLabel
          control={<Android12Switch defaultChecked checked={tempChart} onChange={(e) => { setTempChart(!tempChart) }} />}
          label={tempChart ? "Hide Temperature chart" : "Show Temperature chart"}
        />
        <FormControlLabel
          control={<Android12Switch defaultChecked checked={vacuumChart} onChange={(e) => { setVacuumChart(!vacuumChart) }} />}
          label={vacuumChart ? "Show Vacuums chart" : "Hide Vacuums chart"}
        />
        
        <div className='MyNewClass' style={{ width: '98%' }}>
          <div className="title">TC LIST:</div>
          <div className="list-container">
            {checkList.map((item, index) => {
              return <div key={index}>
                <input value={item} type="checkbox" name='foo' id={index} onChange={handleCheck} />
                <label className={isChecked(item)} for={index}>{item}</label>
              </div>
            })}
            <div key={"CheckFirstZone"}>
              <input value={"Check First Zone's TCs"}  name='foo' type="checkbox" id={"CheckFirstZone"} onChange={handleCheckFirstZone} />
              <label for={"CheckFirstZone"}>Check First Zone's TCs</label>
            </div>
            <div key={"CheckSecondZone"}>
              <input value={"Check Second Zone's TCs"}  name='foo' type="checkbox" id={"CheckSecondZone"} onChange={handleCheckSecondZone} />
              <label for={"CheckSecondZone"}>Check Second Zone's TCs</label>
            </div>
            <div key={"checkAll"}>
              <input value={"Check All"} type="checkbox" id={"checkAll"} onChange={handleCheckAll} />
              <label for={"checkAll"}>Check All</label>
            </div>
          </div>
         
          <div id="my-node">
          <h6 > <b><span style={{color:'red'}}> SP : SetPoint</span> |
          <span style={{color:'red'}}> SPMax-Min : Tolerance</span> |
              <span style={{color:'grey'}}> Z1 : Power % on zone 1</span> |
              <span style={{color:'green'}}> Z2 : Power % on zone 2</span> 
              </b>
            </h6>
            {tempChart ? <>
              <h5> Thermocouples temperature °C and Power % </h5>
              
              <ResponsiveContainer width="90%" height={400}>
                <AreaChart
                  height={250} data={data}
                  syncId="anyId"
                >
                  <CartesianGrid strokeDasharray="9 9" />
                  <XAxis dataKey="time" />
                  <YAxis />
                  <Legend />
                  <Tooltip position={{ x: 0,   y: -150 }} content={<CustomTooltip />} /> 

                  {checked.map((label, index, value) => {

                    var ColorCode = coloredTC ? 'rgb(' + (Math.floor(Math.random() * 230)) + ',' + (Math.floor(Math.random() * 210)) + ',' + (Math.floor(Math.random() * 210)) + ')' : (parseInt(value[index].slice(2)) <= (typeAnita[0] === "24" ? 12 : 6)) ? 'rgb(255,170 ,0)' : 'rgb(0,0,255)';
                    return <Area type="monotone" dataKey={label} stroke={ColorCode} fill="transparent" />
                  }
                  )}

                  <Area type="monotone" dataKey="Z1" stroke="grey" fill="transparent" strokeDasharray="3 3"   />
                  <Area type="monotone" dataKey="Z2" stroke="green" fill="transparent" strokeDasharray="5 5"  />
                  <Area type="monotone" dataKey="SPMin" stroke="red" fill="transparent"  />
                  <Area type="monotone" dataKey="SPMax" stroke="red" fill="transparent" />
                  <Area type="monotone" dataKey="SP" stroke="black" fill="transparent" />
                  
                  
                </AreaChart>
              </ResponsiveContainer>
            </>
              : null}
            {vacuumChart ? <>
              <h5>Vacuum sensors Bar </h5>
              <h6 > <b>
              <span style={{color:'orange'}}> V1 : Vacuum 1</span> |
              <span style={{color:'blue'}}> V2 : Vacuum 2</span> 
              </b>
            </h6>
              <ResponsiveContainer width="90%" height={200}>
                <AreaChart
                  width={970} height={250} data={data2}
                  syncId="anyId"
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="time" />
                  <YAxis domain={[-1, 0]} />
                  <Tooltip  content={<CustomTooltip />} />
                  <Legend />
                  <Area type="monotone" dataKey="V1" stroke="orange" fill="transparent" />
                  <Area type="monotone" dataKey="V2" stroke="blue" fill="transparent" strokeDasharray="2 2" />
                </AreaChart>
              </ResponsiveContainer>
            </> : null} 
            <h3 style={{ color: 'red' }}>Time from : {value[0]} min to {value[1]} min</h3>
            <br />

          </div>
          <Slider style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto' }}
            max={y}
            min={x}
            value={value}
            step={1}
            onChange={handleChange}
            valueLabelDisplay="auto"
            aria-labelledby="range-slider"
            getAriaValueText={valuetext}
          />
          <ul >



          </ul>
        </div><br />
        {(imgSource == "-1" && chartCalledFrom === "1") ? <span style={{ color: 'red' }}> Choose the desired period then click on the button below</span> :chartCalledFrom === "1"? <span style={{ color: 'red' }}> In order to change the report's second page image please click on the button below </span>:null}
        {(chartCalledFrom === "0") ? <span style={{ color: 'red' }}> Click on the button below to take screen-shots</span> : ''}

        <br />

        

        <button color="primary" style={{ margin: 10, backgroundColor : (imgSource == "-1" && chartCalledFrom === "1") ?'red':'blue', color:'white' }} onClick={imprim} aria-label="add to shopping cart">
          <PhotoCameraIcon />
        </button>
        
        <a href="#" onClick={handleClick} style={{ color: "black" }} >
          {detail ? "Hide" : "More details"}
        </a>
        <div id='x'></div>



      </center>

      {chartCalledFrom === "0" ?
        <>
          <h5>Chart analyser : (Testing Phase) </h5>
          <label htmlFor='comparingNumber'> Type a number to compare TCs values with +/-SetPoint </label>
          <input type='number' id='comparingNumber' value={comparingNumber} min='0' onChange={(e) => { SetComparingNumber(e.target.value); }}></input>
          <button onClick={() => descriptionprocess()}>Update result</button>
          {descriptionCourbe.length > 0 &&

            descriptionCourbe.map((item, i) => <><li ><><span style={{ color: '#00008B' }}>{item[0]}</span> <span style={{ color: 'red' }}>{item[1]}</span><span style={{ color: '#00008B' }}> {item[2]}</span> </>
              <ul><li>{item[3]}</li></ul>
            </li></>)}
        </> : null}
      <img hidden src={imgSource}></img>
    </>);
}

export default Charts;
//<button disabled onClick={() => deleteItem(i)}>Add to Report (will be available soon)</button>